
export function nullSafe<T>(func: Function, defaultVal?: T): T | undefined {
    try {
        return func();
    } catch (error) {
        return defaultVal;
    }
}

//Check if has error or  value is null or undefined then return defaultval

export function nullSafeValue<T>(func: Function, defaultVal?: T): T | undefined {
    try {
        if(func()){
            return func();
        }
        return defaultVal;
    
    } catch (error) {
        return defaultVal;
    }
}

